import { trigger, style, state, transition, animate } from '@angular/core';

export const fadeInOutAnimation = trigger(
  'fadeInOutAnimation', [
    state('in', style({ opacity: 1 })),
    transition('void => *', [
      style({ opacity: 0 }),
      animate(200)
    ]),
    transition('* => void', [
      animate(200, style({ opacity: 0 }))
    ])
  ]
);



// WEBPACK FOOTER //
// ./src/animations/fade-in-out.ts